<template>
  <section
    class="relative w-full overflow-hidden bg-cover bg-center bg-no-repeat after:absolute after:left-0 after:top-0 after:block after:h-full after:w-full after:bg-gradient-to-r after:from-white after:to-white/0 after:content-['']"
    :style="bannerStyle"
  >
    <div
      class="container-wrap relative z-10 flex h-mobile-banner py-2 tablet:h-banner"
    >
      <div class="flex w-full flex-col justify-center">
        <div>
          <h1 class="text-h1 banner-title mb-2">
            {{ t('title', { productName }) }}
          </h1>
        </div>
        <div class="mt-8 flex flex-col gap-3 tablet:flex-row tablet:gap-4">
          <TheButton
            :id="isCN ? 'tracking_form' : undefined"
            :to="`/${$i18n.locale}/marketplace/pricing/${$route.params.id}/contact-sales`"
            :title="tGlobal('pricing.request-a-quote')"
            class="w-full tablet:w-[180px]"
          >
            <span class="text-sm">
              {{ tGlobal('pricing.request-a-quote') }}
            </span>
          </TheButton>
          <TheButton
            v-if="pricingDatasheetUrl"
            :to="pricingDatasheetUrl"
            :title="t('item-button')"
            class="w-full tablet:w-[180px]"
            type="outline"
          >
            <span class="text-sm">{{ t('item-button') }}</span>
          </TheButton>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  const { t } = useI18n({ useScope: 'local' });
  const { t: tGlobal } = useI18n({ useScope: 'global' });
  const { isCN } = useLanguage();
  const { blobDomain } = useWebsite();
  const { provideResponsiveImgName } = useImagePath();

  const pricingStore = usePricingStore();
  const { productName, pricingDatasheetUrl } = storeToRefs(pricingStore);

  const bannerStyle = computed((): string => {
    return `background-image: url(${blobDomain.value}/wise-paas-marketplace/product/${provideResponsiveImgName('pricing-banner')})`;
  });
</script>

<i18n lang="json">
{
  "en-int": {
    "title": "{productName} Pricing",
    "item-button": "Download Datasheet"
  },
  "en-jp": {
    "title": "{productName} Pricing",
    "item-button": "Download Datasheet"
  },
  "en-tw": {
    "title": "{productName} Pricing",
    "item-button": "Download Datasheet"
  },
  "en-kr": {
    "title": "{productName} Pricing",
    "item-button": "Download Datasheet"
  },
  "en-americas": {
    "title": "{productName} Pricing",
    "item-button": "Download Datasheet"
  },
  "en-asia-pacific": {
    "title": "{productName} Pricing",
    "item-button": "Download Datasheet"
  },
  "en-emea": {
    "title": "{productName} Pricing",
    "item-button": "Download Datasheet"
  },
  "ja-jp": {
    "title": "{productName} 料金",
    "item-button": "データシートをダウンロード"
  },
  "zh-cn": {
    "title": "{productName} 价格",
    "item-button": "资料下载"
  },
  "zh-tw": {
    "title": "{productName} 定價",
    "item-button": "下載規格書"
  }
}
</i18n>
